/**
 * Whether sending an inquiry for a storefront card aligns with the visitor’s saved wizard search.
 * @param {{ serviceType?: string, subServiceType?: string | null } | null | undefined} wizardState
 * @param {{ ServiceType?: string, _parentServiceType?: string, SubServiceType?: string } | null | undefined} cardService — enriched storefront row
 */
export function storefrontInquiryMatchesWizardSearch(wizardState, cardService) {
  if (!wizardState?.serviceType) return true;

  const wTrade = String(wizardState.serviceType).trim().toLowerCase();
  const cTrade = String(
    cardService?._parentServiceType || cardService?.ServiceType || '',
  )
    .trim()
    .toLowerCase();
  if (wTrade !== cTrade) return false;

  const wSub =
    wizardState.subServiceType != null && String(wizardState.subServiceType).trim() !== ''
      ? String(wizardState.subServiceType).trim().toLowerCase()
      : '';
  const cSub =
    cardService?.SubServiceType != null &&
    String(cardService.SubServiceType).trim() !== ''
      ? String(cardService.SubServiceType).trim().toLowerCase()
      : '';

  if (!cSub) return true;
  if (!wSub) return false;
  return wSub === cSub;
}
